@if (drawer.open()) {
	<div class="df-drawer__backdrop" (click)="drawer.closeDrawer()"></div>
	<aside class="df-drawer df-settings-drawer" role="dialog" aria-modal="true" aria-labelledby="dfSettingsTitle">
		<div class="df-drawer__head">
			<h5 id="dfSettingsTitle" class="df-settings-drawer__title">Settings</h5>
			<button type="button" class="btn-close" aria-label="Close" (click)="drawer.closeDrawer()"></button>
		</div>
		<div class="df-drawer__body">
			<div class="df-set-group">
				<div class="df-set-group__title">Display</div>
				<div class="df-set-row">
					<div class="df-set-row__text">
						<div class="df-set-row__label">Theme</div>
						<div class="df-set-row__help">Follows this account on every browser you sign in to.</div>
					</div>
					<div class="df-set-row__ctl">
						<div class="df-tabs df-tabs--sm df-settings-drawer__tabs" role="tablist">
							@for (opt of themeOptions; track opt.value) {
								<button
									type="button"
									role="tab"
									class="df-tabs__tab"
									[class.df-tabs__tab--active]="userSettings.settings().theme === opt.value"
									[attr.aria-selected]="userSettings.settings().theme === opt.value"
									[disabled]="disabled"
									(click)="setTheme(opt.value)"
								>
									<i class="bi {{ opt.icon }} me-1"></i>{{ opt.label }}
								</button>
							}
						</div>
					</div>
				</div>
			</div>
			<div class="df-set-group">
				<div class="df-set-group__title">Presentation</div>
				<div class="df-set-row">
					<div class="df-set-row__text">
						<div class="df-set-row__label">Presentation mode</div>
						<div class="df-set-row__help">
							Limits the funds list to funds flagged for presentation. Display only — direct links to any fund keep working.
						</div>
					</div>
					<div class="df-set-row__ctl">
						<div class="form-check form-switch m-0">
							<input
								id="df-set-presentation"
								class="form-check-input"
								type="checkbox"
								role="switch"
								[checked]="userSettings.settings().presentationMode"
								[disabled]="disabled"
								(change)="togglePresentation($any($event.target).checked)"
							/>
						</div>
					</div>
				</div>
				@if (userSettings.settings().presentationMode) {
					<div class="df-set-note">
						<i class="bi bi-funnel-fill"></i>
						<span>{{ presentation.counts().shown }} of {{ presentation.counts().total }} funds flagged for presentation.</span>
						<button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="manageFlags()">Manage flags</button>
					</div>
				}
			</div>
		</div>
		<div class="df-settings-drawer__footer">
			@if (disabled) {
				<span class="df-save df-save--err"><i class="bi bi-x-circle-fill"></i>Settings unavailable — using defaults.</span>
			} @else {
				@switch (userSettings.saveState()) {
					@case ('saving') {
						<span class="df-save"><span class="spinner-border spinner-border-sm"></span>Saving…</span>
					}
					@case ('saved') {
						<span class="df-save df-save--ok"><i class="bi bi-check-circle-fill"></i>Saved</span>
					}
					@case ('error') {
						<span class="df-save df-save--err"><i class="bi bi-x-circle-fill"></i>Save failed. Setting not applied.</span>
					}
					@default {
						<span class="df-save df-save--idle">Changes save as you make them.</span>
					}
				}
			}
		</div>
	</aside>
}
